export type FaqItem = { q: string; a: string };

export type ReviewItem = { name: string; role: string; text: string };

export const siteInfo = {
  brand: "看料88",
  slogan: "今日猛料 · 热门大瓜 · 全网汇总",
  intro:
    "看料88是一个专注文娱热点的话题聚合站。我们把每天散落在各处的热门话题、节目动向和讨论焦点整理成一条清晰的时间线，让你在一个页面里就能看完全网正在聊什么。",
  email: "contact@kanliao88.example",
  serviceHours: "每日 08:00 - 24:00 实时更新",
  established: "2021",
  baseCity: "线上运营",
  stats: [
    { label: "每日更新话题", value: "120+" },
    { label: "累计收录合集", value: "8,600+" },
    { label: "日均浏览人次", value: "45万" },
    { label: "编辑审核人工复核", value: "100%" },
  ],
  principles: [
    {
      icon: "ri-shield-check-line",
      title: "先核实，再发布",
      text: "每条话题在收录前都会经过来源比对，无法确认的信息会明确标注为“待核实”，而不是当作事实传播。",
    },
    {
      icon: "ri-time-line",
      title: "按时间线整理",
      text: "热点容易越传越乱，我们把同一话题的进展按时间顺序排列，方便快速看清事情的来龙去脉。",
    },
    {
      icon: "ri-emotion-happy-line",
      title: "围观也要有边界",
      text: "不鼓励人身攻击和未经证实的指控，涉及个人隐私的内容一律不做放大处理。",
    },
    {
      icon: "ri-refresh-line",
      title: "持续更新，不追一锤子",
      text: "话题有后续就更新，没有后续也会标注完结，不让读者停留在半截信息里。",
    },
  ],
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "猛料合集", to: "/materials" },
  { label: "关于我们", to: "/about" },
];

export const faqs: FaqItem[] = [
  {
    q: "看料88 的内容多久更新一次？",
    a: "话题库全天滚动更新，热门话题通常在事件出现后的数小时内完成整理上线。首页的“今日热榜”每天上午十点和晚上八点各刷新一次排序。",
  },
  {
    q: "网站上的内容都是可靠的吗？",
    a: "我们会比对多个公开来源后再收录，并对无法交叉验证的部分标注“待核实”。即便如此，热点话题本身仍在发展变化，建议把它当作线索而不是最终结论。",
  },
  {
    q: "为什么有些话题后来看不到后续了？",
    a: "如果话题在合理时间内没有新的公开进展，我们会把它标记为“已完结”并保留在合集里，方便你回头查看这条线索的完整过程。",
  },
  {
    q: "可以投稿或提供线索吗？",
    a: "可以。你可以通过页脚的邮箱联系我们，附上公开可查的来源链接。我们会安排编辑核对，采纳与否都会回复。",
  },
  {
    q: "看料88 会涉及个人隐私内容吗？",
    a: "不会。我们不放大涉及私人生活、住址、联系方式等隐私信息，涉及未成年人的内容一律不予收录。这是内容审核的硬性红线。",
  },
  {
    q: "订阅之后会收到什么？",
    a: "订阅者每周会收到一封汇总邮件，包含当周热度最高的十条话题和各自的进展状态，不发送营销内容。",
  },
];

export const reviews: ReviewItem[] = [
  {
    name: "阿柚",
    role: "资深吃瓜群众",
    text: "最大的好处是不用来回刷十几个平台，一个页面就能把前因后果看完，尤其是时间线整理得很清楚。",
  },
  {
    name: "老陈",
    role: "文娱从业者",
    text: "做选题的时候常来看看大家对同一条话题的关注点在哪里，比单纯看数据更直观。",
  },
  {
    name: "Momo",
    role: "普通上班族",
    text: "午休刷十分钟就够了，不会像短视频那样越刷越焦虑，信息密度刚刚好。",
  },
];

export const hotTopics = [
  "综艺赛制改版",
  "悬疑短剧集",
  "音乐节票价",
  "理性吃瓜",
  "国风通勤穿搭",
  "运动综艺真实性",
  "冷门项目破圈",
  "热搜话题逻辑",
];

export const positioning = [
  {
    icon: "ri-focus-3-line",
    title: "一个页面看完全网",
    text: "不追求收录最多，而是把同一话题的零散信息合并成一条清晰的线索，减少你在多个平台之间来回切换的时间。",
  },
  {
    icon: "ri-node-tree",
    title: "按时间线而不是按热度",
    text: "热度只决定排序，时间线决定呈现。先发生了什么、后来怎么发展，比哪一条转发量最高更重要。",
  },
  {
    icon: "ri-eye-line",
    title: "把不确定的地方说清楚",
    text: "遇到无法交叉验证的信息，我们会明确标注“待核实”，而不是用模糊表述把它包装成结论。",
  },
];

export const milestones = [
  { year: "2021", title: "从一个话题开始", text: "最初只是把一条热门话题的来龙去脉整理成时间线，发在内部群里给同事看。" },
  { year: "2022", title: "确立六个栏目", text: "内容逐渐按综艺、影视、音乐、网络话题、时尚和赛事分成六个方向，编辑取向开始清晰。" },
  { year: "2023", title: "上线双人复核", text: "所有话题在发布前至少经过两位编辑交叉核对来源，无法确认的部分标注为待核实。" },
  { year: "2024", title: "推出今日热度榜", text: "按全网讨论量生成每小时刷新的热度榜，让读者一眼看到当下最值得关注的话题。" },
  { year: "2025", title: "开放热点周报", text: "开始向订阅者发送每周汇总邮件，内容只包含当周话题和进展，不夹杂任何营销内容。" },
  { year: "2026", title: "话题库持续扩张", text: "累计收录合集超过八千条，编辑流程和内容边界也在不断调整。" },
];